import Vue from 'vue';
import { map, find, get, flatMap, round } from 'lodash';

const root = document.querySelector('#dci-layout');

if (root) {
    new Vue({
        el: root,
        delimiters: ['${', '}'],
        data: {
            job: JSON.parse(root.dataset.job),
            products: JSON.parse(root.dataset.products),
            configuration: JSON.parse(root.dataset.configuration)
        },
        computed: {
            maxv() {
                const VArray = flatMap(this.configuration, (system) => {
                    return map(system.mppts, (mppt) => {
                        const { details: { voc, vDeratingCelsius } } = find(this.products.pvModules.panels, ['id', parseInt(mppt.panel.id)]);
                        const pvMaxVoltage = voc - (this.temperature - 25) * vDeratingCelsius;
                        return Math.round(pvMaxVoltage * mppt.series);
                    });
                });

                return VArray;
            },

            maxvString() {
                return this.maxv ? `${this.maxv}V` : 'Error';
            },

            isc() {
                const IArray = flatMap(this.configuration, (system) => {
                    return map(system.mppts, (mppt) => {
                        const { details: { panelIsc } } = find(this.products.pvModules.panels, ['id', parseInt(mppt.panel.id)]);
                        return round(panelIsc * 1.25 * mppt.parallel, 2);
                    });
                });

                return IArray;
            },

            temperature() {
                return get(this.job, 'details.temperature.min', NaN);
            }
        }
    });
}
